import * as React from "react";
import { RecommendationItem } from "../../calcBusterTypes";
import { Header, Table } from "@amzn/awsui-components-react";
import { getSavingsArray, USDollar } from "../../util";

const Savings = (recommendations: RecommendationItem[]) => {
  if (!recommendations) {
    return "No recommendations";
  }
  const savingsArray = getSavingsArray(recommendations);
  return savingsArray.length === 0 ? (
    <>No Savings</>
  ) : (
    <>
      <Header> Savings </Header>
      <Table
        variant="embedded"
        columnDefinitions={[
          {
            id: "service",
            header: "Service",
            cell: (item) => item.name,
            isRowHeader: true,
          },
          {
            id: "amount",
            header: "Amount",
            cell: (item) => USDollar.format(item.value),
          },
        ]}
        items={savingsArray}
      />
    </>
  );
};

export default Savings;
